export default __webpack_public_path__ + "static/media/smithsonian.e4dab2c3.jpg";